import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import listingsTracker from '../../../apps/listings/service/tracker';
import categoryTracker from '../../../apps/categories/service/tracker';
import { AppContext as CategoryContext } from '../../../apps/categories/components/CategoryContext';
import { AppContext as ListingsContext } from '../../../apps/listings/components/ListingsContext';
import './index.scss';

const ESC_KEY = 'Escape';

class ExplanationVideo extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            isVideoOpen: false
        };

        this.closeTextBox = this.toggleTextBox.bind(this, false);
        this.toggleVideoPlayer = this.toggleVideoPlayer.bind(this);
        this.escFunction = this.escFunction.bind(this);
        this.tracker = props.categoryPage ? categoryTracker : listingsTracker;
    }

    componentDidUpdate() {
        if (this.state.isVideoOpen && this.videoEl.play) {
            this.videoEl.play();
            this.videoEl.addEventListener('webkitendfullscreen', () => {
                this.setState({ isVideoOpen: false });
            });
        }
    }

    toggleTextBox(isOpen) {
        this.setState({ isOpen });
    }

    stopPropagation(e) {
        e.stopPropagation();
    }

    toggleVideoPlayer(e, enteredVideo) {
        e.preventDefault();
        this.setState((state) => ({ ...state, isVideoOpen: !state.isVideoOpen, isOpen: false }));

        const { categoryName, title } = this.props.subcat;

        enteredVideo && this.tracker.trackHowFiverrWorksVideo({ categoryName, subcategoryName: title });
    }

    escFunction(event) {
        if (this.state.isVideoOpen && event.key === ESC_KEY) {
            this.toggleVideoPlayer(event);
        }
    }

    render() {
        const { isOpen, isVideoOpen } = this.state,
            { subcategoryName, src, subcat, hasVideoLink } = this.props;

        const videoTag = hasVideoLink ? 'shared.explanation_video.title' : 'shared.how_fiverr_works',
            playBtnClass = classNames('play', { 'separated-video-link': hasVideoLink });

        const AppContext = this.props.categoryPage ? CategoryContext : ListingsContext;
        return (
            <AppContext.Consumer>
                {({ isTouch }) => (
                    <div className="search-perseus">
                        <div className="explanation-video" onKeyDown={this.escFunction}>
                            <p className="description">
                                {subcat.subtitle}
                                {!isTouch && <button className={playBtnClass} onClick={(e) => this.toggleVideoPlayer(e, true)}>
                                    <i className="fa fa-play-circle"/>
                                    <span><I18n k={videoTag}/></span>
                                </button>}
                            </p>
                            {isOpen && (
                                <div className="tooltip">
                                    <i className="fa fa-times" onClick={this.closeTextBox}/>
                                    <i className="fa fa-graduation-cap"/>
                                    <h4><I18n k={'shared.explanation_video.subtitle'}/>{subcategoryName}</h4>
                                    <small className="subtitle-text">
                                        <I18n k={'shared.explanation_video.subtitle_text'}/>
                                    </small>
                                </div>
                            )}
                            {isVideoOpen && <div className="overlay" onClick={this.toggleVideoPlayer}>
                                <div className="pop-up-video" onClick={this.stopPropagation}>
                                    <a href="#!" className="close" onClick={this.toggleVideoPlayer}>
                                        <span>&times;</span>
                                    </a>
                                    <video className="embedded-video"
                                        ref={(el) => this.videoEl = el}
                                        preload="auto"
                                        src={src}
                                        autoPlay
                                        allowFullScreen
                                        controls/>
                                </div>
                            </div>}
                        </div>
                    </div>
                )}
            </AppContext.Consumer>
        );
    }
}

ExplanationVideo.propTypes = {
    subcategoryName: PropTypes.string,
    src: PropTypes.string,
    hasVideoLink: PropTypes.bool
};

export default ExplanationVideo;
